import React, { useEffect,useState } from "react";
import shape6 from "../../images/shape-6.png";
import shape24 from "../../images/shape-24.png";
import shape23 from "../../images/shape-23.png";
import shape5 from "../../images/shape-5.png";
import shape8 from "../../images/shape-8.png";
import author from "../../images/author-03.jpg";
import shape12 from "../../images/shape-12.png";
import contact from "../../images/contact.jpg";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import axios from 'axios';
import swal from 'sweetalert';

const Contact = () => {
  const [firstname, setFirstName] = useState('');
  const [lastname, setLastName] = useState('');

	const [email, setEmail] = useState('');
	const [message, setMessage] = useState('');
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const formData = new FormData();

  const handleSubmit = (event) => {
		event.preventDefault();
    // const formData = new FormData();
    formData.append('firstname', firstname);
    formData.append('lastname', lastname);
    formData.append('email', email);
    formData.append('message', message);
  
    sendData(formData);
  }
	  
    const sendData = (data) => {
      axios.post('https://maps-medics-be.onrender.com/add_contact_us', data)
        .then(response => {
        console.log(response.data);
        swal("Good job!", "Your Data has been sent successfully!", "success");
        })
        .catch(error => {
        console.log(error);			swal("Oops!", "Please try again!", "error");
  
        });
      }
    
 
  return (
    <>
      {/* <Navbar/> */}
      <div className="section " ></div>
      <div
        className="section "

      ></div>

      <div class="section page-banner">
        <div
          style={{
            backgroundColor: "rgba(0,0,0,0.4)",
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            class="container"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div class="page-banner-content">
              <h2 class="title" style={{ color: "#fff" }}>
                Contact <span>Us.</span>
              </h2>
            </div>
          </div>
        </div>
      </div>
      <div class="section " style={{ padding: "100px 0px 100px 0px" }}>
        <div class="container">
          <div className="row" style={{ padding: "0px 15px 0px 15px" }}>
            <div className="col-md-6" style={{ padding: "0px 0px 50px 0px" }}>
              <h3
                style={{
                  fontSize: "46px",
                  fontWeight: "900",
                  fontFamily: "Playfair Display",
                  lineHeight: "1.2em",
                  color: "#25283a",
                  margin: "0 0 25px 0",
                }}
              >
                Feel Free To Reach Out!
              </h3>
              <div
                style={{
                  fontSize: "15px",
                  fontWeight: "300",
                  fontFamily: "Poppins",
                  lineHeight: "24px",
                  color: "#383838",
                  padding: "0px 0px 50px 0px",
                }}
              >
                Connect with us. Get in touch for support, feedback or just to
                say hello. We're here to help you succeed.
              </div>
              <div style={{ marginBottom: "20px" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginRight: "40px",
                    marginLeft: "25px",
                  }}
                >
                  <div
                    className="contactContainer"
                    style={{ marginBottom: "20px", width: "95%" }}
                  >
                    <div
                      className="iconWrapper"
                      style={{
                        textAlign: "center",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <div
                        className="col-md-2 ico"
                        style={{ display: "flex", justifyContent: "end" }}
                      >
                        <div class="item-icon-title" className="col" style={{ marginLeft: "35%" }} >
                          <div
                            class="item-icon"
                            style={{
                              backgroundColor: "#ffc600",
                              fontSize: "28px",
                              borderRadius: "50%",
                              color: "#fff",
                              padding: ".5em",
                              width: "65px",
                              height: "65px",
                            }}
                          >
                            <i class="fa-solid fa-location-dot"></i>{" "}
                          </div>
                          {/* <div class="item-title"></div> */}
                        </div>
                        {/* <div className='iconBg' style={{backgroundColor:'#ffc600', fontSize:'35px', borderRadius:'50%', color:'#fff'}}><i class="fa-solid fa-location-dot" style={{width:'1em', height:'1em', position:'relative', display:'block', fontWeight:'900'}}></i></div> */}
                      </div>
                      <div className="col-md-1"></div>
                      <div className="col-md-9 ico2">
                        <div className="row">
                          <h3
                            className="ico2h3"
                            style={{
                              fontSize: "20px",
                              fontWeight: "800",
                              fontFamily: "Playfair Display",
                              textAlign: "left",
                            }}
                          >
                            Office Address:
                          </h3>
                          <p
                            className="ico2p"
                            style={{
                              fontSize: "15px",
                              fontWeight: "400",
                              fontFamily: "Poppins",
                              textAlign: "left",
                              lineHeight: "1.2em",
                              color: "#383838",
                            }}
                          >
                            {" "}
                            College of Medicine, Modern University for
                            Technology and Information <br />
                            Cairo, Egypt
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginRight: "40px",
                    marginLeft: "25px",
                  }}
                >
                  <div
                    className="contactContainer"
                    style={{ marginBottom: "20px", width: "95%" }}
                  >
                    <div
                      className="iconWrapper"
                      style={{
                        textAlign: "center",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <div
                        className="col-md-2 ico"
                        style={{ display: "flex", justifyContent: "end" }}
                      >
                        <div class="item-icon-title" className="col" style={{ marginLeft: "35%" }}>
                          <div
                            class="item-icon"
                            style={{
                              backgroundColor: "#ffc600",
                              fontSize: "28px",
                              borderRadius: "50%",
                              color: "#fff",
                              padding: ".5em",
                              width: "65px",
                              height: "65px",
                            }}
                          >
                            <i class="fa-solid fa-phone-volume"></i>{" "}
                          </div>
                          {/* <div class="item-title"></div> */}
                        </div>
                        {/* <div className='iconBg' style={{backgroundColor:'#ffc600', fontSize:'35px', borderRadius:'50%', color:'#fff'}}><i class="fa-solid fa-location-dot" style={{width:'1em', height:'1em', position:'relative', display:'block', fontWeight:'900'}}></i></div> */}
                      </div>
                      <div className="col-md-1"></div>
                      <div className="col-md-9 ico2">
                        <div className="row">
                          <h3
                            className="ico2h3"
                            style={{
                              fontSize: "20px",
                              fontWeight: "800",
                              fontFamily: "Playfair Display",
                              textAlign: "left",
                            }}
                          >
                            Give Us A Call:
                          </h3>
                          <p
                            className="ico2p"
                            style={{
                              fontSize: "15px",
                              fontWeight: "400",
                              fontFamily: "Poppins",
                              textAlign: "left",
                              lineHeight: "1.2em",
                              color: "#383838",
                            }}
                          >
                            {" "}
                            Mobile-no: +2 0111 222 33 59
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginRight: "40px",
                    marginLeft: "25px",
                  }}
                >
                  <div
                    className="contactContainer"
                    style={{ marginBottom: "20px", width: "95%" }}
                  >
                    <div
                      className="iconWrapper"
                      style={{
                        textAlign: "center",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <div
                        className="col-md-2 ico"
                        style={{ display: "flex", justifyContent: "end" }}
                      >
                        <div class="item-icon-title" className="col" style={{ marginLeft: "35%" }}>
                          <div
                            class="item-icon"
                            style={{
                              backgroundColor: "#ffc600",
                              fontSize: "28px",
                              borderRadius: "50%",
                              color: "#fff",
                              padding: ".5em",
                              width: "65px",
                              height: "65px",
                            }}
                          >
                            <i class="fa-solid fa-envelope-open-text"></i>{" "}
                          </div>
                          <div class="item-title"></div>
                        </div>
                        {/* <div className='iconBg' style={{backgroundColor:'#ffc600', fontSize:'35px', borderRadius:'50%', color:'#fff'}}><i class="fa-solid fa-location-dot" style={{width:'1em', height:'1em', position:'relative', display:'block', fontWeight:'900'}}></i></div> */}
                      </div>
                      <div className="col-md-1"></div>
                      <div className="col-md-9 ico2">
                        <div className="row">
                          <h3
                            className="ico2h3"
                            style={{
                              fontSize: "20px",
                              fontWeight: "800",
                              fontFamily: "Playfair Display",
                              textAlign: "left",
                            }}
                          >
                            Email Address:
                          </h3>
                          <p
                            className="ico2p"
                            style={{
                              fontSize: "15px",
                              fontWeight: "400",
                              fontFamily: "Poppins",
                              textAlign: "left",
                              lineHeight: "1.2em",
                              color: "#383838",
                            }}
                          >
                            {" "}
                            Website: www.mti.mapsmedics.com <br />
                            Email: info@mapsmedics.com
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="contactUs">
                <div className="backgroundOverlay"></div>
                <div
                  className="container sendMessage"
                  style={{ position: "relative", padding: "0" }}
                >
                  <div className="row">
                    <div className="col-md-12 ">
                      <h3
                        className="text-center"
                        style={{
                          fontSize: "50px",
                          fontWeight: "700",
                          color: "#fff",
                          lineHeight: "1.2em",
                          fontFamily: "Playfair Display",
                          marginBottom: "20px",
                        }}
                      >
                        Send us a message
                      </h3>
                    </div>
                    <div className="col-md-12" style={{ margin: "24px auto" }}>
                      <form action="" className="container" id="contact-form" method="post" onSubmit={handleSubmit}>
                        <div className="row" style={{ padding: "10px 0" }}>
                          <label
                            htmlFor=""
                            style={{
                              color: "#fff",
                              fontWeight: "700",
                              fontSize: "16px",
                              lineHeight: "1.3",
                              margin: "0 0 4px 0",
                              fontFamily: "Poppins",
                            }}
                          >
                            Name{" "}
                            <span
                              style={{ color: "#ff0000", fontWeight: "400" }}
                            >
                              *
                            </span>
                          </label>

                          <div className="col-md-6">
                            <input
                              type="text"
                              style={{
                                borderRadius: "20px",
                                color: "#333",
                                fontSize: "16px",
                                border: "1px solid #ccc",
                                padding: "6px 10px",
                                height: "38px",
                                width: "100%",
                              }}
                              // value={firstname}  
                              required 
                              name="firstname" 
                              onInput={(e) => formData.set('firstname', e.target.value)}
                            />
                            <label
                              htmlFor=""
                              style={{
                                display: "block",
                                fontSize: "13",
                                float: "none",
                                fontWeight: "400",
                                lineHeight: "1.3",
                                margin: "4px 0 0",
                                padding: "0",
                                color: "#fff",
                              }}
                            >
                              First
                            </label>
                          </div>
                          <div className="col-md-6">
                            <input
                              type="text"
                              style={{
                                borderRadius: "20px",
                                color: "#333",
                                fontSize: "16px",
                                border: "1px solid #ccc",
                                padding: "6px 10px",
                                height: "38px",
                                width: "100%",
                              }}
                              // value={lastname}
                                required name="lastname"
                              onInput={(e) => formData.set('lastname', e.target.value)} 
                            />
                            <label
                              htmlFor=""
                              style={{
                                display: "block",
                                fontSize: "13",
                                float: "none",
                                fontWeight: "400",
                                lineHeight: "1.3",
                                margin: "4px 0 0",
                                padding: "0",
                                color: "#fff",
                              }}
                            >
                              Last
                            </label>
                          </div>
                        </div>
                        <div className="row" style={{ padding: "10px 0" }}>
                          <label
                            htmlFor=""
                            style={{
                              color: "#fff",
                              fontWeight: "700",
                              fontSize: "16px",
                              lineHeight: "1.3",
                              margin: "0 0 4px 0",
                              fontFamily: "Poppins",
                            }}
                          >
                            Email{" "}
                            <span
                              style={{ color: "#ff0000", fontWeight: "400" }}
                            >
                              *
                            </span>
                          </label>
                          <div className="col-md-12">
                            <input
                              type="text"
                              style={{
                                borderRadius: "20px",
                                color: "#333",
                                fontSize: "16px",
                                border: "1px solid #ccc",
                                padding: "6px 10px",
                                height: "38px",
                                width: "100%",
                              }}
                              name="email"  
                              // value={email} 
                              required
                              onInput={(e) => formData.set('email', e.target.value)} 
                              
                            />
                            {/* <label htmlFor="" style={{display:'block', fontSize:'13', float:'none', fontWeight:'400', lineHeight:'1.3', margin:'4px 0 0', padding:'0',color:'#fff'}}>First</label> */}
                          </div>
                        </div>
                        <div className="row" style={{ padding: "10px 0" }}>
                          <label
                            htmlFor=""
                            style={{
                              color: "#fff",
                              fontWeight: "700",
                              fontSize: "16px",
                              lineHeight: "1.3",
                              margin: "0 0 4px 0",
                              fontFamily: "Poppins",
                            }}
                          >
                            Comment or Messsage
                          </label>
                          <div className="col-md-12">
                            <textarea
                            
                              id=""
                              style={{
                                borderRadius: "20px",
                                color: "#333",
                                fontSize: "16px",
                                border: "1px solid #ccc",
                                padding: "6px 10px",
                                height: "120px",
                                width: "100%",
                              }}
                              name="message" 
                              // value={message}
                              onInput={(e) => formData.set('message', e.target.value)} 

                            ></textarea>
                          </div>
                        </div>
                        <div className="row">
                          <div
                            className="col-md-12"
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              width: "100%",
                            }}
                          >
                            <button
                              style={{
                                width: "100%",
                                backgroundColor: "#ffc600",
                                color: "#fff",
                                borderRadius: "20px",
                                fontSize: "1em",
                                padding: "10px 15px",
                                fontWeight: "500",
                                lineHeight: "1.2em",
                                fontFamily: "Poppins",
                                border: "none",
                              }}
                            >
                              Submit
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <div class="contact-wrapper">
                    <div class="row align-items-center">
                        <div class="col-lg-6">

                            <div class="contact-info">

                                <img class="shape animation-round" src={shape12} alt="Shape"/>

                           
                                <div class="single-contact-info">
                                    <div class="info-icon">
                                    <i class="fa-solid fa-phone-volume"></i>                                    </div>
                                    <div class="info-content">
                                        <h6 class="title">Give Us A Call</h6>
                                        <p>Mobile-no: <a href="tel:+201112223359" style={{textDecoration:'none', color:'#000'}}>+2 0111 222 33 59</a></p>

                                    </div>
                                </div>
                               
                           
                                <div class="single-contact-info">
                                    <div class="info-icon">
                                    <i class="fa-regular fa-envelope"></i>
                                    </div>
                                    <div class="info-content">
                                        <h6 class="title">Email Address:</h6>
                                        <p>Website: <a href="mailto:www.mti.mapsmedics.com" style={{textDecoration:'none', color:'#000'}}>www.mti.mapsmedics.com</a></p>
                                        <p>Email: <a href="mailto:www.mti.mapsmedics.com" style={{textDecoration:'none', color:'#000'}}>info@mapsmedics.com</a></p>

                                    </div>
                                </div>
                               
                           
                                <div class="single-contact-info">
                                    <div class="info-icon">
                                    <i class="fa-solid fa-location-dot"></i>
                                    </div>
                                    <div class="info-content">
                                        <h6 class="title">Office Address:</h6>
                                        <p>College of Medicine, Modern University for Technology and Information
Cairo, Egypt</p>
                                    </div>
                                </div>
                               
                            </div>
                           

                        </div>
                        <div class="col-lg-6">

                          
                            <div class="contact-form">
                                <h3 class="title">Feel Free To <span>Reach Out!</span></h3>

                                <div class="form-wrapper">
                                    <h6>Connect with us. Get in touch for support, feedback or just to say hello. We're here to help you succeed.</h6>
                                    <img src={contact} alt="" />
                                </div>
                            </div>

                        </div>
                    </div>
                </div> */}

        </div>
      </div>
      {/* <Footer /> */}
    </>
  );
}

export default Contact;
